import React from 'react';
import {AuthService} from './AuthService';



const AuthContext = React.createContext<AuthService|undefined>(undefined);

export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;
export default AuthContext;
